export default "https://fiverr-res.cloudinary.com/npm-assets/@fiverr/search_perseus/apps/album_cover_design.08b3e16.svg";